import React from "react";

const NoChartData = () => {
  return (
    <div className="flex w-full justify-center">
      <div
        className="text-center p-4 mb-4 w-full max-w-xl text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400"
        role="alert"
      >
        No data
      </div>
    </div>
  );
};

NoChartData.propTypes = {};

export default NoChartData;
